import { Fragment, React } from 'react';

import _ from 'lodash';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { useDispatch } from 'react-redux';

import CircularProgress from '@material-ui/core/CircularProgress';

import ImagesComponent from './ImagesComponent';
import classes from './ShortlistTable.module.css';

import tourComplete from '../../assets/img/completeTourIcon.svg';
import dragHandle from '../../assets/img/dragIcon.svg';
import tourSchedule from '../../assets/img/scheduleTourIcon.svg';
import tourRequest from '../../assets/img/tourIcon.svg';
import useAddShortlistedoption from '../../store/contexts/useAddShortlistedoption';
import { formatDatefromTimeStamp, strToArray, reorderShortListData } from '../../utils/utils';

const TourTable = ({ shortlist, surveyData }) => {
  const { putOption, inProgress } = useAddShortlistedoption();
  const dispatch = useDispatch();

  let shortListCopy = reorderShortListData(shortlist);

  const shortListCopyLength = shortListCopy?.filter((obj) => obj !== 'undefined')?.length;

  /* Sort Order for Tour
   All scheduled- ascending
   Requested not scheduled
   not Requested
   completed */

  const confirmedTourArray = shortListCopy
    ?.filter(
      (option) =>
        option?.tourScheduledDate != null &&
        option?.tourScheduledSlot != null &&
        !option?.tourCompleted,
    )
    .sort((date1, date2) => new Date(date1?.scheduleDate) - new Date(date2?.scheduleDate));

  const completedTourArray = shortListCopy
    ?.filter(
      (option) =>
        option?.tourCompleted &&
        option?.tourScheduledDate != null &&
        option?.tourScheduledSlot != null,
    )
    .sort((date1, date2) => new Date(date1?.scheduleDate) - new Date(date2?.scheduleDate));

  const notRequestedTourArray = shortListCopy?.filter(
    (option) =>
      option?.tourRequestedDate == null &&
      option?.tourScheduledDate == null &&
      !option?.tourCompleted,
  );

  const requestedTourArray = shortListCopy?.filter(
    (option) =>
      option?.tourRequestedDate != null &&
      option?.tourScheduledDate == null &&
      !option?.tourCompleted,
  );

  shortListCopy = _.concat(
    confirmedTourArray,
    _.sortBy(requestedTourArray, 'requestedDateTime'),
    notRequestedTourArray,
    completedTourArray,
  );

  const dragendHandler = (params) => {
    if (!params.destination || params.destination.index === params.source.index) return;
    const srcI = params.source.index;
    const desI = params.destination.index;

    shortListCopy.splice(desI, 0, shortListCopy.splice(srcI, 1)[0]);

    shortListCopy = shortListCopy.map((obj, index) => ({
      ...obj,
      shortlistedOrder: index + 1,
    }));

    const ids = shortListCopy.map((item) => item.optionId);

    putOption(
      () => {
        dispatch({
          type: 'SET_SHORTLIST_IDS',
          ids: ids,
        });
      },
      'RESET',
      ids,
      shortListCopy,
    );
  };

  const createMarkup = (data) => {
    return { __html: data };
  };

  return (
    <Fragment>
      <thead>
        <tr>
          <th className={classes.dragWidth}>
            <img src={dragHandle} alt=".." />
          </th>
          <th className={classes.colWidth}>Photos</th>
          <th className={classes.headCol}>Name</th>
          <th className={classes.headCol}>Tour Details</th>
          <th className={classes.headCol}>Arrival Details</th>
        </tr>
      </thead>
      {typeof shortListCopyLength === 'undefined' && (
        <tbody>
          <tr>
            <td colSpan="5" className={classes.centerAlign}>
              Nothing is shortlisted
            </td>
          </tr>
        </tbody>
      )}
      {shortListCopyLength > 0 && (
        <DragDropContext onDragEnd={dragendHandler}>
          <Droppable droppableId="droppale-4">
            {(provided, _) => (
              <tbody ref={provided.innerRef} {...provided.droppableProps}>
                {shortListCopy?.map((item, idx) => (
                  <Draggable key={item?.id} draggableId={'draggable4-' + item?.id} index={idx}>
                    {(provided, snapshot) => (
                      <tr
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        style={{
                          ...provided.draggableProps.style,
                          boxShadow: snapshot.isDragging ? '0 0 0.4rem #666' : '',
                          zIndex: '200',
                        }}
                      >
                        <td className={classes.dragWidth} {...provided.dragHandleProps}>
                          {<img src={dragHandle} alt=".." />}
                        </td>
                        <td className={classes.imgRow}>
                          <ImagesComponent images={item?.images} width="200px" height="110px" />
                        </td>

                        <td className={classes.nameRow}>{item?.optionName}</td>
                        <td>
                          {item?.tourScheduledDate && (
                            <div>
                              {!item?.tourCompleted && (
                                <div>
                                  <div className={classes.leftText}>
                                    <img src={tourSchedule} alt="Tour Schedule" />
                                  </div>
                                  <span className={classes.displayRow}>
                                    <span>Tour Scheduled</span>
                                    <br />
                                    {formatDatefromTimeStamp(
                                      item.tourScheduledDate,
                                      'MMM DD, YYYY',
                                    )}{' '}
                                    - {item.tourScheduledSlot}
                                  </span>
                                </div>
                              )}
                              {item?.tourCompleted && (
                                <div>
                                  <div className={classes.leftText}>
                                    <img src={tourComplete} alt="Tour Schedule" />
                                  </div>
                                  <span className={classes.displayRow}>
                                    Tour Completed <br />
                                    {formatDatefromTimeStamp(
                                      item.tourScheduledDate,
                                      'MMM DD, YYYY',
                                    )}{' '}
                                    - {item.tourScheduledSlot}
                                  </span>
                                </div>
                              )}
                              <br />
                              <span className={classes.displayRow}>
                                {item.contactName && (
                                  <span>
                                    Provider Contact Name: {item.contactName} <br />
                                  </span>
                                )}
                                {item.contactNumber && (
                                  <span>Provider Contact Number: {item.contactNumber}</span>
                                )}
                              </span>
                            </div>
                          )}

                          {!item?.tourScheduledDate &&
                            item?.tourRequestedDate &&
                            !item?.tourCompleted &&
                            item?.tourRequestedDate.length > 0 && (
                              <div>
                                <div className={classes.leftText}>
                                  <img
                                    src={tourRequest}
                                    alt="tour request"
                                    width="20"
                                    height="20"
                                  />
                                </div>
                                <span className={classes.displayRow}>
                                  Tour Requested
                                  <br />
                                  {item?.sortedRequestedDates?.map((requestedDate, index) => (
                                    <span key={`${requestedDate}-${index}`}>
                                      {requestedDate}
                                      <br />
                                    </span>
                                  ))}
                                </span>{' '}
                              </div>
                            )}
                        </td>
                        <td>
                          {item?.arrivalDetails && (
                            <div dangerouslySetInnerHTML={createMarkup(item.arrivalDetails)} />
                          )}
                        </td>
                      </tr>
                    )}
                  </Draggable>
                ))}
              </tbody>
            )}
          </Droppable>
        </DragDropContext>
      )}
      {inProgress && (
        <span className={classes.spinner}>
          <CircularProgress color="inherit" />
        </span>
      )}
    </Fragment>
  );
};

export default TourTable;
